<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="120px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        style="position: relative"
      >
        <el-form-item
          label="状态"
          prop="IsQy"
          :rules="[
            { required: true, message: '请选择状态', trigger: 'blur' },
          ]"
        >
          <el-switch
            v-model="state.model.IsQy"
            inline-prompt
            active-text="上架"
            inactive-text="下架"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="GysId"
          :rules="[
            { required: true, message: '请选择供应商', trigger: 'blur' },
          ]"
          style="flex: 1; margin-right: 0"
        >
          <el-select
            v-model="state.model.GysId"
            placeholder="--请选择供应商--"
            value-key="Mc"
            :disabled="!Array.isArray(state.gysData)"
          >
            <el-option
              v-for="item in state.gysData"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="美食名称"
          prop="Mc"
          :rules="[
            { required: true, message: '请输入美食名称', trigger: 'blur' },
          ]"
          style="width: 100%"
        >
          <el-input v-model="state.model.Mc" placeholder="例如：特色精品套餐" />
        </el-form-item>
        <el-form-item label="简介" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Jj"
            :autosize="{ minRows: 2 }"
            placeholder="美食的简要描述"
          />
        </el-form-item>

        <el-form-item label="是否预约" prop="IsYuyue" style="width: 30%">
          <el-switch
            v-model="state.model.IsYuyue"
            inline-prompt
            active-text="需要"
            inactive-text="不需要"
          />
        </el-form-item>
        <el-form-item
          v-if="state.model.IsYuyue"
          label="提前天数"
          prop="YuyueTianShu"
          style="width: 30%; margin-right: 0"
        >
          <el-input-number
            v-model="state.model.YuyueTianShu"
            :min="1"
            controls-position="right"
            style="width: 100%"
            placeholder="请指定天数"
          />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref } from "vue";
import {
  meishi_add,
  meishi_edit,
  meishi_detail,
  gongyingshang_select,
} from "@/http/api";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
      },
    });
    onMounted(() => {
      loadGys();

      if (props.id) {
        meishi_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = {
              IsQy: res.data.IsQy,
              Mc: res.data.Mc || "",
              Jj: res.data.Jj || "",
              GysId: res.data.GysId || null,
              IsYuyue: res.data.IsYuyue || false,
              YuyueTianShu: res.data.YuyueTianShu || null,
            };
          }
        });
      }
    });

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        const submitData = { ...state.model };

        if (props.id) {
          meishi_edit(props.id, submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          meishi_add(submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    return {
      state,
      formDom,
      onSubmit,
    };
  },
};
</script>
